/**
 * Lazy-load and play Video Hero MP4 on span-7 case study cards (hover / focus-within).
 * Mobile (≤767px): video visible and playing continuously.
 */
const CASE_STUDY_CARD_MOBILE_MQ =
	typeof window !== "undefined" ? window.matchMedia("(max-width: 767px)") : null;

function isCaseStudyCardMobile() {
	return CASE_STUDY_CARD_MOBILE_MQ && CASE_STUDY_CARD_MOBILE_MQ.matches;
}

function applyCaseStudyCardVideoSrcAndPlay(video) {
	const lazy = video.getAttribute("data-src");
	if (lazy && !video.getAttribute("data-src-applied")) {
		video.setAttribute("data-src-applied", "1");
		video.src = lazy;
		video.removeAttribute("data-src");
		video.load();
	}
	const p = video.play();
	if (p !== undefined) {
		p.catch(() => {});
	}
}

export function initCaseStudyCardHoverVideo(scopeRoot = document) {
	const prefersReduced =
		typeof window !== "undefined" &&
		window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	if (prefersReduced) {
		return;
	}

	const root = scopeRoot && scopeRoot.querySelectorAll ? scopeRoot : document;
	const cards = root.querySelectorAll(".case-study-card--has-hover-video");

	cards.forEach((card) => {
		const video = card.querySelector(".case-study-card__video");
		if (!video) {
			return;
		}

		if (isCaseStudyCardMobile()) {
			applyCaseStudyCardVideoSrcAndPlay(video);
			return;
		}

		function pauseAndReset() {
			video.pause();
			try {
				video.currentTime = 0;
			} catch (_) {
				// ignore
			}
		}

		card.addEventListener("mouseenter", () => applyCaseStudyCardVideoSrcAndPlay(video));
		card.addEventListener("mouseleave", pauseAndReset);

		card.addEventListener(
			"focusin",
			(e) => {
				if (card.contains(e.relatedTarget)) {
					return;
				}
				applyCaseStudyCardVideoSrcAndPlay(video);
			},
			true
		);
		card.addEventListener(
			"focusout",
			(e) => {
				if (card.contains(e.relatedTarget)) {
					return;
				}
				pauseAndReset();
			},
			true
		);
	});
}
